import {
  useReactMutation,
  useTranslation,
  getPostServicePromise
} from '@invision/core';
import type {
  SecurityResetPasswordRequest,
  SecurityResetPasswordResponse
} from 'invApi';

/**
 * Hook for initiating password reset process
 * Sends reset email with token to user if username exists
 *
 * API: POST Security/ResetPassword
 * Headers: None (unauthenticated)
 */
export function useResetPasswordMutation() {
  const { t } = useTranslation();

  return useReactMutation<
    SecurityResetPasswordResponse,
    SecurityResetPasswordRequest
  >(
    ['resetPassword'],
    (request: SecurityResetPasswordRequest) =>
      getPostServicePromise(
        { path: 'Security/ResetPassword' },
        {
          payload: request,
          faults: {
            '108': t('Email failed to send'),
            '111': t('Username not found'),
            '121': t('Password is locked and cannot be changed'),
            '155': t('Too many reset attempts. Please try again later.'),
            '156': t('Single Sign-On user reset password not allowed')
          }
        }
      ),
    {},
    {
      useLoadingIndicator: true
    }
  );
}
